if (!customElements.get('recommended-products')) {
  class RecommendedProducts extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
    }

    connectedCallback() {
      if (!this.productId) {
        return;
      }
      this.closest('.section-inner').classList.remove('hidden');

      this.addEventListener('click', (e) => {
        const anchor = e.target.closest('[href][data-product-id][data-position]');
        if (!anchor) return;
        
        e.preventDefault();        
        window.FastSimonSDK.event({
          eventName: window.FastSimonEventName.RecommendationProductClicked,
          data: {
            productID: anchor.dataset.productId,
            position: Number(anchor.dataset.position) + 1,
            sourceProductID: this.productId
          }
        }); 
        
        window.location.href = anchor.href;
      });
      
      poll(() => {
        return window.FastSimonSDK;
      }, 10000, 150).then(() => {     
        window.FastSimonSDK.productRecommendation({
          productID: this.productId,
          collectionIDs: ['267808899139'],
          specs:[
            {
              sources: ["related_views", "similar_products"],
              maxSuggestions: 10,
              widgetID: "custom-upsell-widget-sparky",
            }
          ],
          callback: (response) => {
            const products = response?.payload?.[0]?.payload;     
            if (!products.length) {
              this.closest('.section-inner').classList.add('hidden');
              return;
            }
            
            this.innerHTML = `
              <a href="#pc-end-of-carousel-rv-${this.productId}" class="skip-carousel button primary button-md inline-block absolute left-[-10000px] top-auto w-[1px] h-[1px] overflow-hidden focus:static focus:w-max focus:h-auto">Skip carousel</a>
              <swiper-container
                class="w-full flex gap-2"
                space-between="16"
                scrollbar="true"
                scrollbar-el="#scroll-bar-rec"
                slides-per-view="1.25"
                breakpoints='{"1024":{"slidesPerView":3.5,"space-between":8}}'
                inject-styles='[":host .swiper {overflow: visible}", ":host .swiper-wrapper {display: flex; align-items: stretch;}"]' 
                navigation="true"
                navigation-prev-el="#prev-rec"
                navigation-next-el="#next-rec"
                free-mode="true"
                mousewheel-control="true"
                mousewheel-force-to-axis="true"
              >
              ${products?.slice(0, 12).map((product, i) => `
                <swiper-slide class="h-auto min-w-[calc(100%/4)] w-[calc(100%/3.5)]">
                  <intersection-loader 
                    data-url="${product.u}" 
                    data-section-id="product-tile"
                    data-preserve-classes="true"
                    class="h-full"
                  ><div class="block bg-pampas rounded-xl h-full z-0 relative">
                    <div class="loader flex items-center justify-center">
                      <span class="block w-12 h-12">
                        <svg class="animate-spin -ml-1 mr-3 h-full w-full text-accent1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      </span>
                    </div>
                  </div>
                  </intersection-loader>
                </swiper-slide>
              `).join('')}    
              </swiper-container>
            `;
          }
        });
      }).catch((err) => {
        console.error('Fast Simon took too long to load.', err)
      });
    }
  }

  customElements.define('recommended-products', RecommendedProducts);
}